module.exports = __webpack_public_path__ + "static/media/AIA_loading.837d3134.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/img/aia/AIA_loading.mp4
// module id = 74
// module chunks = 0